import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import project1 from "../assets/images/project-1.jpg";
import project2 from "../assets/images/project-2.jpg";
import project3 from "../assets/images/project-3.jpg";
import project4 from "../assets/images/project-4.jpg";
import project5 from "../assets/images/project-5.png";
import project6 from "../assets/images/project-6.png";
import project7 from "../assets/images/project-7.png";
import project8 from "../assets/images/project-8.png";


import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper";

const Project = () => {
  const projects = [
    {
      img: project7,
      name: "Subs4Sale",

      // github_link: "https://github.com/usman-174/enterprice-frontend",
      live_link: "https://gorgeous-twilight-92923b.netlify.app/",
    },
    {
      img: project8,
      name: "Gadget-Store E-commerce",

      github_link: "https://github.com/usman-174/gadget-store-client",
      live_link: "https://stirring-kataifi-f90695.netlify.app",
    },
    {
      img: project1,
      name: "Companies License Ltd",

      github_link: "https://github.com/usman-174/enterprice-frontend",
      live_link: "https://visionary-sprinkles-fbf731.netlify.app",
    },
    {
      name: "amingo api app",

      img: project5,
      github_link: "https://github.com/usman-174/character-appp",
      live_link: "https://rainbow-praline-e1e783.netlify.app",
    },
    {
      name: "Real-Time Expense Tracker",

      img: project6,
      github_link: "https://github.com/usman-174/react-expense",
      live_link: "https://hilarious-brioche-73cd9c.netlify.app/",
    },
    {
      img: project2,

      name: "Air Condition",
      github_link:
        "https://github.com/usman-174/NextJs-Web-Clone-Air-conditioner-",
      live_link: "https://incomparable-monstera-c0d557.netlify.app/",
    },
    {
      img: project3,

      name: "Inheritage App",
      github_link: "https://github.com/usman-174/Next-Design",
      live_link: "https://figma-next.vercel.app/",
    },
    {
      img: project4,
      name: "NFT DATE MARKETPLACE",
      status: false,
      github_link: null,
      live_link: "https://next-date-app.vercel.app/",
    },
  ];
  return (
    <section id="projects" className="py-10 text-white">
      <div className="text-center">
        <h3 className="text-5xl font-semibold">
          My <span className="text-cyan-600">Projects</span>
        </h3>
        <p className="text-gray-400 mt-3 text-lg">My awesome works</p>
      </div>
      <br />
      <div className="flex max-w-6xl gap-6 px-5 mx-auto items-center justify-center relative">
        <div className="w-full">
          <Swiper
            slidesPerview={1.2}
            spaceBetween={50}
            cardsEffect="true"
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              1160: {
                slidesPerView: 3,
              },
            }}
            loop={true}
            autoplay={{
              delay: 3000,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination, Autoplay]}
          >
            {projects.map((project_info, i) => (
              <SwiperSlide key={i}>
                <div className="h-fit w-full p-4 my-10 bg-slate-700 rounded-xl">
                  <img
                    src={project_info.img}
                    alt=""
                    className="rounded-lg w-full md:h-52 h-44"
                  />
                  <h3 className="text-xl my-4">{project_info.name}</h3>
                  <div className="flex gap-3">
                    {project_info?.github_link && (
                      <a
                        href={project_info.github_link}
                        className="text-cyan-600 bg-gray-800 px-2 py-1 inline-block"
                      >
                        Github
                      </a>
                    )}
                    {project_info?.live_link && (
                      <a
                        href={project_info.live_link}
                        target="_blank"
                        rel="noreferrer"
                        className="text-cyan-600 bg-gray-800 px-2 py-1 inline-block"
                      >
                        Live Demo
                      </a>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Project;
